import { render } from "./NavsTabsPage.vue?vue&type=template&id=3465fb21&ts=true"
import script from "./NavsTabsPage.vue?vue&type=script&lang=ts"
export * from "./NavsTabsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__